import { useChatTopicsContext } from './ChatTopicsContext';
import React, { useEffect, useRef, useState } from 'react';
import DsButton from '../../DsButton';
import { listChatTopics } from '../../../../api/chatTopics';
import { TopicSummary } from './ChatTopicModal';

export default function ChatTopicTargetExpansion({ scope, conversationId, hasTopics, onSelect }: { scope: "individual" | "event" | "group"; conversationId: string; hasTopics: boolean; onSelect: (topic: any) => void }) {
  const parent = useChatTopicsContext();
  const [expanded, setExpanded] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [nextCursor, setNextCursor] = useState<string | null>(null);
  const targetKey = `${parent?.role}:${scope}:${conversationId}`;
  const currentTarget = useRef(targetKey); currentTarget.current = targetKey;
  useEffect(() => { setExpanded(false); setRows([]); setNextCursor(null); }, [targetKey]);
  if (!hasTopics || !conversationId) return null;
  const load = async (append = false) => {
    const expected = targetKey;
    setLoading(true); setError('');
    try {
      const data = await listChatTopics({ actorType: parent?.role, scope, conversationId: String(conversationId), limit: 5, ...(append && nextCursor ? { cursor: nextCursor } : {}) });
      if (currentTarget.current !== expected) return;
      setRows((previous) => append ? [...previous, ...data.topics.filter((item) => !previous.some((old) => old.id === item.id))] : data.topics);
      setNextCursor(data.nextCursor);
    } catch (failure: any) { if (currentTarget.current === expected) setError(failure.message); }
    finally { if (currentTarget.current === expected) setLoading(false); }
  };
  const toggle = (event: React.MouseEvent) => {
    event.stopPropagation(); setExpanded(!expanded);
    if (!expanded) void load();
  };
  return <div className="chat-topic-target" onClick={(event: React.MouseEvent) => event.stopPropagation()} onTouchStart={(event: React.TouchEvent) => event.stopPropagation()}>
    <DsButton variant="ghost" className="chat-topic-target__toggle" aria-label={expanded ? 'スレッドを折りたたむ' : 'スレッドを展開する'} aria-expanded={expanded} onClick={toggle}><span aria-hidden="true">{expanded ? '▴' : '▾'}</span></DsButton>
    {expanded && <div className="chat-topic-target__rows">{rows.map((topic: any) => <TopicSummary key={topic.id} topic={topic} onSelect={onSelect} />)}{loading && <p role="status">読み込んでいます…</p>}{error && <p role="alert">{error}<DsButton variant="ghost" onClick={() => load(rows.length > 0)}>再読み込み</DsButton></p>}{nextCursor && <DsButton variant="ghost" disabled={loading} onClick={() => load(true)}>さらに表示</DsButton>}</div>}
  </div>;
}
